export default __webpack_public_path__ + "static/media/linkIcon.8e858619.svg";